// @ts-check

import { bindActionCreators } from 'redux';

const NOOP = () => () => {};

/** @param {Error} e */
const ERROR_DEFAULT = (e) => {
  throw e;
};

/**
 * @type {typeof import('@xingternal/hops-redux').dispatchableFetch}
 */
const dispatchableFetch =
  (options) =>
  // @ts-ignore
  (dispatch, _getState, { fetchJson }) => {
    const actions = bindActionCreators(
      {
        onStart: options.onStart || NOOP,
        onSuccess: options.onSuccess || NOOP,
        onError: options.onError || ERROR_DEFAULT,
        onEnd: options.onEnd || NOOP,
      },
      dispatch
    );

    actions.onStart();
    return fetchJson(options.url, options)
      .then(actions.onSuccess)
      .catch(actions.onError)
      .then(actions.onEnd)
      .catch(console.error.bind(console)); // eslint-disable-line no-console
  };

export default dispatchableFetch;
